import { apiSlice } from '@/store/api/apiSlice'

/**
 * Evaluated state of the backend-fed development gates. The backend
 * (GET /api/public/v1/feature-flags/) is the single source of truth — it
 * evaluates the OpenFeature/AppConfig flags and returns a flat key→boolean map.
 */
export interface FeatureFlagsResponse {
  flags: Record<string, boolean>
}

export const featureFlagsApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getFeatureFlags: builder.query<FeatureFlagsResponse, void>({
      query: () => '/public/v1/feature-flags/',
      providesTags: ['FeatureFlag'],
    }),
  }),
})

export const { useGetFeatureFlagsQuery } = featureFlagsApi
